import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import { useState } from 'react';
import Tx from '../Tx';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import { api } from '../../maps/data.js';
import { useEffect } from 'react';
import InstallerSelectCameraCard from '../InstallerSelectCameraCard';
import DialogContent from '@mui/material/DialogContent';

export default function InstallerAddCameraToFieldDialog(props) {
    const { onClose, edgeId } = props;

    const [cameras, s_cameras] = useState([]);

    const installerId = zibi.user.installerId;

    const getCameras = async () => {
        const res = await api({
            type: 'getCameras',
            data: {
                edgeId
            }
        });
        s_cameras(res);
    }

    useEffect(() => { getCameras() }, []);

    return (
        <Dialog
            open={true}
            onClose={onClose}
            maxWidth="md"
            fullWidth={true}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-descriptionx">

            <DialogContent>
                {
                    cameras.map((camera, idx) => <div key={idx} style={{ maxWidth: 200, padding: 10, display: 'inline-block' }}>
                        <InstallerSelectCameraCard camera={camera} onSelect={props.onSelect} />
                    </div>)
                }
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}><Tx>g.cancel</Tx></Button>
            </DialogActions>
        </Dialog>)
}